import { Money, convertMoneyToFloat, formatMoney } from '@betterment/core';

export function sharesFromMoneyTradeEstimate(moneyAmount: Money | undefined, price: Money) {
  if (!moneyAmount) return undefined;
  const shares = convertMoneyToFloat(moneyAmount) / convertMoneyToFloat(price);
  const precision = shares < 0.01 ? 6 : 2;
  return Math.trunc(shares * 10 ** precision) / 10 ** precision;
}

export function sharesTradeEstimateCopy(moneyAmount: Money | undefined, price: Money) {
  if (!moneyAmount) return '';
  const shares = sharesFromMoneyTradeEstimate(moneyAmount, price);
  const shareWord = shares === 1 ? 'share' : 'shares';
  return `Est. ${shares} ${shareWord} at ${formatMoney(price)}/share`;
}

export function moneyFromSharesTradeEstimate(sharesAmount: number | undefined, price: Money) {
  if (!sharesAmount) return undefined;
  return Money(price.cents * sharesAmount);
}

export function moneyTradeEstimateCopy(sharesAmount: number | undefined, price: Money) {
  if (!sharesAmount) return '';
  const estimatedAmount = moneyFromSharesTradeEstimate(sharesAmount, price);
  if (!estimatedAmount) return '';
  return `Est. ${formatMoney(estimatedAmount)} at ${formatMoney(price)}/share`;
}
